import { Component, input } from '@angular/core';

@Component({
  selector: 'app-metric-card',
  standalone: true,
  templateUrl: './metric-card.component.html',
  styleUrl: './metric-card.component.scss',
})
export class MetricCardComponent {
  label = input.required<string>();
  value = input.required<string | number>();
  hint = input<string>('');
  tone = input<'neutral' | 'good' | 'warn' | 'danger'>('neutral');
}
